"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var DinfoAction;
(function (DinfoAction) {
    DinfoAction.ON_UPDATE_DISTRICT_INFO = 'ON_UPDATE_DISTRICT_INFO';
    DinfoAction.SET_DISTRICT_INFO = 'SET_DISTRICT_INFO';
    DinfoAction.onUpdateDistrictInfo = typesafe_actions_1.createAction(DinfoAction.ON_UPDATE_DISTRICT_INFO, function (resolve) { return function (ids) { return resolve(ids); }; });
    DinfoAction.setDinfo = typesafe_actions_1.createAction(DinfoAction.SET_DISTRICT_INFO, function (resolve) {
        return function (name, blob, avgSale, avgRent, url) {
            if (blob === void 0) { blob = ''; }
            if (avgSale === void 0) { avgSale = 0; }
            if (avgRent === void 0) { avgRent = 0; }
            if (url === void 0) { url = ""; }
            return resolve({ name: name, blob: blob, avgSale: avgSale, avgRent: avgRent, url: url });
        };
    });
})(DinfoAction || (DinfoAction = {}));
exports.default = DinfoAction;
